import { RoleListView } from '../../../components/Role';
import { UserType } from '../../../types';

export function VendorUserRoles() {
  return <RoleListView type={UserType.Vendor} />;
}
